'use client';

import { c as _c } from "react/compiler-runtime";
import './child-bio-image.scss';
import { useTranslation } from 'react-i18next';
import { HtmlBlock } from '@sola/ark-core/atoms/html/html.tsx';
import { ChildImageVariantEnum, getChildImageUrl } from '@sola/ark-core/utils/child-image.ts';
import type { ChildAvailabilityItem, ChildDetails } from '@sola/schema/dotcom/children/child.ts';
import { Image } from '../../atoms/image/image.tsx';
import { useSacImageAltText } from '../../utils/alt-text.ts';
import placeholder from './placeholder.png';
type ChildBioImageProps = {
  availability: ChildAvailabilityItem;
  details: ChildDetails;
};
export const ChildBioImage = t0 => {
  const $ = _c(19);
  const {
    details,
    availability
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["bio", "children", "geo"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  const {
    imageUrl,
    name,
    hangul
  } = details;
  const {
    gender,
    isSpecialNeeds,
    isOrphan,
    isInHivAffectedArea,
    minDaysWaiting,
    icp: t2
  } = availability;
  const {
    country
  } = t2;
  let t3;
  if ($[1] !== imageUrl) {
    t3 = getChildImageUrl(imageUrl, ChildImageVariantEnum.Full, 500);
    $[1] = imageUrl;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const childImage = t3;
  const titleAndAlt = useSacImageAltText(gender, country, hangul, minDaysWaiting, name.preferred, isOrphan, isSpecialNeeds, isInHivAffectedArea);
  const t4 = childImage || placeholder as unknown as string;
  let t5;
  if ($[3] !== t4 || $[4] !== titleAndAlt) {
    t5 = {
      url: t4,
      alt: titleAndAlt
    };
    $[3] = t4;
    $[4] = titleAndAlt;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== childImage || $[7] !== t5) {
    t6 = <Image key={childImage} image={t5} lazyLoad="eager" aspectRatio="3-4" className="ChildBioImage__Figure__img" />;
    $[6] = childImage;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== hangul.preferred || $[10] !== minDaysWaiting || $[11] !== name.preferred || $[12] !== t) {
    t7 = t("bio:waitingCaption", {
      childName: name.preferred,
      koreanName: hangul.preferred,
      days: minDaysWaiting
    });
    $[9] = hangul.preferred;
    $[10] = minDaysWaiting;
    $[11] = name.preferred;
    $[12] = t;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t7) {
    t8 = <figcaption className="ChildBioImage__Figure__figcaption label label-xl"><HtmlBlock htmlString={t7} /></figcaption>;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t6 || $[17] !== t8) {
    t9 = <div className="ChildBioImage xl:pr-comfy-xl"><figure className="ChildBioImage__Figure">{t6}{t8}</figure></div>;
    $[16] = t6;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
};